import ReactSelect, { StylesConfig } from 'react-select';
import styled from 'styled-components';
import { FormInputWithValidationProps } from '../models/FormInputWithValidation';
import { SelectProps } from '../models/SelectProps';
import { forwardRef } from 'react';
import { InputPlaceholder } from 'shared/placeholders';

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

const StyledLabel = styled.div`
  display: flex;
  gap: 4px;
  transition: 0.8s;

  label {
    color: rgb(62, 76, 89);
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    letter-spacing: 0em;
    line-height: 1rem;
    font-weight: 400;
  }
`;

const StyledSelect = styled(ReactSelect)`
  width: 100%;

  .react-select__control {
    border-radius: 48px;
    transition: 0.8s;
    color: rgb(82, 96, 109);
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    letter-spacing: 0em;
    line-height: 1.5rem;
    font-weight: 400;
    box-shadow: none;
    cursor: pointer;

    &:hover {
      background: rgb(245, 247, 250);
    }
  }

  .state-error {
    border-color: #dc3545;

    :hover {
      border-color: #dc3545;
    }
  }

  .react-select__control--is-focused {
    border: 1px solid rgb(45, 204, 167) !important;
  }

  // Menu

  .react-select__menu {
    border-radius: 4px;
    box-shadow:
      rgba(62, 76, 89, 0.08) 0px 4px 16px 0px,
      rgba(82, 96, 109, 0.08) 0px 16px 40px -8px;
  }

  .react-select__menu-list {
    border-radius: 4px;
    padding: 8px;
    margin: 0px;
    background: rgb(255, 255, 255);
  }

  .react-select__option {
    list-style: none;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 8px 12px;
    background: rgb(255, 255, 255);
    border-radius: 2px;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
    transition: 0.5s;
    color: rgb(62, 76, 89);

    &:hover {
      background: rgb(245, 247, 250);
    }
  }
`;

const colourStyles: StylesConfig<any> = {
  option: (styles, { isSelected }) => ({
    fontFamily: 'Inter, sans-serif',
    fontWeight: isSelected ? 'bold' : 400,
    fontSize: '0.875rem',
    letterSpacing: '0em',
    lineHeight: '1.5rem',
  }),
};

export type LegacySelectProps = FormInputWithValidationProps &
  SelectProps &
  Partial<HTMLElement> & {
    label?: string;
  };

export const Select = forwardRef<any, LegacySelectProps>(
  (
    {
      name,
      registerOptions,
      defaultValue,
      label,
      placeholder,
      onChange,
      onBlur,
      value,
      classNames,
      isLoading,
      ...rest
    },
    ref,
  ) => {
    const handleChange = (e: any) => {
      const obj = { ...e };
      // Es necesario eliminar el target porque sino el form-hook lo toma como un evento del DOM.
      delete obj.target;
      onChange(obj);
    };
    return (
      <SelectContainer>
        {label && (
          <StyledLabel>
            <label color="neutral">{label}</label>
          </StyledLabel>
        )}
        {isLoading ? (
          <InputPlaceholder />
        ) : (
          <StyledSelect
            ref={ref}
            onChange={handleChange}
            onBlur={onBlur}
            name={name}
            value={value || ''}
            defaultValue={defaultValue || ''}
            placeholder={placeholder || 'Selecciona...'}
            styles={colourStyles}
            classNames={classNames}
            classNamePrefix="react-select"
            {...rest}
          />
        )}
      </SelectContainer>
    );
  },
);
